<template>
  <div class="workbenchSupplier">
    <van-form label-width="120px">
      <van-field
        v-model="form.ShareMessage"
        :label="$t.workbench.shareMessageCN"
        :placeholder="$t.information.input"
        type="textarea"
        rows="5"
      />

      <van-field
        v-model="form.ShareMessageEn"
        :label="$t.workbench.shareMessageEN"
        :placeholder="$t.information.input"
        type="textarea"
        rows="5"
      />

      <van-field :label="$t.workbench.shareQrCode">
        <template #input>
          <van-image
            width="80"
            height="80"
            :src="shareQrCode"
            @click="qrcodePreview(shareQrCode)"
          />
        </template>
        <template #button>
          <van-button
            size="small"
            type="info"
            @click="onSaveShareQrCode"
            v-if="isApp && shareQrCode"
            >{{ $t.meta.saveToAlbum }}</van-button
          >
        </template>
      </van-field>

      <div style="padding: 16px; margin-bottom: 16px">
        <van-button round block type="info" @click="editUserShareMessage">{{
          $t.workbench.saveMessage
        }}</van-button>
      </div>
    </van-form>
  </div>
</template>
<script>
import Vue from "vue";
import { Form, Field, Button, Icon, Image, ImagePreview } from "vant";
import { isAPP } from "@/plugins/environment/type.js";

Vue.use(Form).use(Field).use(Button).use(Icon).use(Image).use(ImagePreview);

export default {
  name: "workbenchSupplier",
  data() {
    return {
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      UserId: JSON.parse(localStorage.getItem("auth")).userInfo.UserId,
      isApp: isAPP(),
      form: {},
      shareQrCode: "",
    };
  },
  created() {
    var data = JSON.parse(localStorage.getItem("workbenchSupplier"));
    this.form = data;
    this.getShareQrCode();
  },
  methods: {
    qrcodePreview(data) {
      ImagePreview({ images: [data], closeable: true, startPosition: 0 });
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    getShareQrCode() {
      var param = { WebSiteUrl: "" };
      this.$api.user.supplierBusinessSharingQrCodeByBase64(param).then((res) => {
        this.shareQrCode = "data:image/png;base64," + res.data;
      });
    },
    onSaveShareQrCode() {
      var element = document.createElement("img");
      element.setAttribute("src", this.shareQrCode);
      this.$commonEnv.commonAction(this.$commonEnv.actionType.downloadImage, {
        element: element,
        successText: this.$t.meta.saveSuccess,
        failText: this.$t.meta.saveError,
      });
    },
    editUserShareMessage() {
      this.$commonMethod.showLoading();
      var param = {
        ShareMessage: this.form.ShareMessage,
        ShareMessageEn: this.form.ShareMessageEn,
      };
      this.$api.user
        .editUserShareMessage(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.workbenchSupplier {
  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }
  .van-cell::after {
    border: none !important;
  }
}
</style>
